import React from 'react';
import { Button, Text } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useConsent } from './useConsent';
import { trackerById, CONSENT_CATEGORIES } from './trackerCatalog';
import classes from './BlockedEmbed.module.css';

/**
 * Ce que voit le lecteur à la place d'un contenu tiers qu'il n'a pas autorisé.
 *
 * Il occupe la place de l'iframe, pour que la mise en page ne bouge pas selon
 * le choix. Faire disparaître l'embed sans rien dire rendrait la proposition
 * incompréhensible et priverait le lecteur du moyen de revenir dessus.
 *
 * Deux sorties, volontairement de portée différente : afficher **ce** contenu
 * (déblocage ponctuel, rien n'est écrit sur le terminal), ou autoriser la
 * finalité entière. Exiger un consentement global pour voir une vidéo serait
 * le chantage que le critère « libre » interdit.
 */
export function BlockedEmbedPlaceholder({ serviceId, className = '', style }) {
  const { allowServiceOnce, allowCategory } = useConsent();
  const tracker = trackerById(serviceId);
  const label = tracker?.label || 'Contenu tiers';

  return (
    <div className={`${classes.frame} ${className}`.trim()} style={style} role="group" aria-label={`Contenu ${label} bloqué`}>
      <FontAwesomeIcon
        icon={icon({ name: 'lock-keyhole', style: 'light' })}
        style={{ fontSize: 24 }}
        className={classes.icon}
        aria-hidden="true"
      />
      <Text size="sm" fw={600}>Contenu {label} bloqué</Text>
      {tracker && (
        <Text size="xs" c="dimmed" maw={420}>
          {tracker.issuer} — {tracker.purpose}. {tracker.storage}.
        </Text>
      )}
      <div className={classes.actions}>
        <Button size="xs" variant="filled" onClick={() => allowServiceOnce(serviceId)}>
          Afficher ce contenu
        </Button>
        <Button
          size="xs"
          variant="default"
          onClick={() => allowCategory(CONSENT_CATEGORIES.embeds)}
        >
          Autoriser tous les contenus tiers
        </Button>
      </div>
    </div>
  );
}

export default BlockedEmbedPlaceholder;
